<template>
  <el-row :gutter="30" class="preview-text text-left">
    <el-col :span="24" :md="12">
      <p>
        <span>ชื่อหน่วยงาน: </span><span v-if="agency">{{ agency }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ประเภทหน่วยงาน: </span
        ><span v-if="agencyType">{{ getAgencyLabel(agencyType) }} </span>
        <i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24">
      <p>
        <span>ที่อยู่: </span><span v-if="address">{{ address }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ตำบล/แขวง: </span
        ><span v-if="subDistrict">{{ subDistrict }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>อำเภอ/เขต: </span><span v-if="district">{{ district }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>จังหวัด: </span><span v-if="province">{{ province }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>รหัสไปรษณีย์: </span><span v-if="postcode">{{ postcode }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
  </el-row>
</template>

<script>
export default {
  props: {
    agency: {
      type: String,
      default() {
        return "";
      },
    },
    agencyType: {
      default() {
        return "";
      },
    },
    etc: {
      type: String,
      default() {
        return "";
      },
    },
    address: {
      type: String,
      default() {
        return "";
      },
    },
    subDistrict: {
      type: String,
      default() {
        return "";
      },
    },
    district: {
      type: String,
      default() {
        return "";
      },
    },
    province: {
      type: String,
      default() {
        return "";
      },
    },
    postcode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    agencyTypeList() {
      return this.$store.state.agencyTypeList;
    },
  },
  methods: {
    getAgencyLabel(id) {
      let filter = this.agencyTypeList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        if (filter[0].id == 8) {
          return this.etc;
        }
        return filter[0].label;
      } else {
        return "";
      }
    },
  },
};
</script>